import { SidebarItemsType } from "../../types/sidebar";

import {
  Bookmark,
  InsertDriveFile as File,
  Language as Globe,
  NoteAdd as FilePlus,
  Psychology as Mindmap,
} from "@mui/icons-material";

const mainSection = [
  {
    href: "/",
    icon: Globe,
    title: "Search",
  },
  // {
  //   href: "/populate",
  //   icon: FilePlus,
  //   title: "Populate",
  // },
  {
    href: "/bookmarks",
    icon: Bookmark,
    title: "Bookmarks",
  },
  {
    href: "/mindmap",
    icon: Mindmap,
    title: "Mindmap",
  },
  {
    href: "/",
    icon: File,
    title: "Files",
    children: [],
  },
] as SidebarItemsType[];

const navItems = [
  {
    title: "Main",
    pages: mainSection,
  },
];

export default navItems;
